const SentConfirmationModal = ({
  show,
  selectedMethod,
  onGoToDashboard,
  t,
}) => {
  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content rounded shadow-lg">
          <div className="modal-header">
            <h5 className="modal-title fw-bold">
              {selectedMethod === "sms" ? t("sms_sent") : t("email_sent")}
            </h5>
          </div>
          <div className="modal-body">
            <p>
              {selectedMethod === "sms"
                ? t("success_sms_sent")
                : t("success_email_sent")}
            </p>
          </div>
          <div className="modal-footer border-0 pt-0 d-flex justify-content-end gap-2">
            <button className="btn btn-success" onClick={onGoToDashboard}>
              {t("go_to_dashboard") || t("dashboard")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SentConfirmationModal;
